import select2 from 'select2/dist/js/select2.full.min';
select2();

function initSelect2($el) {
  // protect against multiple initializations
  if ($el.hasClass('select2-hidden-accessible')) {
    return;
  }

  let options = {
    width: '50%',
  };

  $el.select2(options);
}

function destroySelect2($el) {
  if ($el.hasClass('select2-hidden-accessible')) {
    $el.select2('destroy');
  }
}

$(document).on('turbo:load', function () {
  $(document).on('cocoon:after-insert', function () {
    initSelect2($('.select2'));
  });

  initSelect2($('.select2'));
});

$(document).on('turbo:before-cache', function () {
  $('.select2').each(function () {
    destroySelect2($(this));
  });
});
